import { Layers, Sparkles } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from 'src/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import type { SimilarityData } from 'src/services/api/getNoveltiesBestCandidates';

type SimilarProductAttributesProps = {
  similarity: SimilarityData;
};

export function SimilarProductAttributes({
  similarity,
}: SimilarProductAttributesProps): ReactElement {
  const { t } = useTranslation('novelties');

  return (
    <div className='flex items-center justify-center gap-2'>
      {similarity.is_same_model && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Badge className='text-xs' variant='outline'>
                <Layers className='mr-1 size-3' />
                {t('Model')}
              </Badge>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('Same model')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      {similarity.is_same_collection && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Badge className='text-xs' variant='outline'>
                <Sparkles className='mr-1 size-3' />
                {t('Collection')}
              </Badge>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('Same collection')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      {!(similarity.is_same_model || similarity.is_same_collection) && (
        <span className='text-layout-foreground-secondary text-xs'>-</span>
      )}
    </div>
  );
}
